import React, { useEffect } from "react";
import { useHistory } from "react-router";
import backgroundSecundario from "../../../assets/images/Background/backgroundSecundario.png";
import useSomaPlaceUser from "../../../Hooks/SomaPlaceContext";

const BemVindo = (props) => {
  const { somaPlaceUser, status, fetchStatus, latestContract, signature } = useSomaPlaceUser();

  const history = useHistory();
  useEffect(() => {
    if (status && status === 200 && somaPlaceUser) {
      if (!signature || signature.contractId !== latestContract.id) {
        if (history) {
          history.push(props.location.pathname + "/my-register");
          //console.log("abc", status);
        }
      }
    }
  }, [fetchStatus, history, latestContract, props, props.navigation, signature, somaPlaceUser, status]);

  return (
    <img src={backgroundSecundario} style={{ maxWidth: "100%", display: "block" }} alt="Por onde vamos começar?" />
  );
};

export default BemVindo;
